import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { QueuingSystemSharedModule } from '../../shared';
import { ErrorComponent } from './error.component';
import { ERROR_ROUTES } from './error.route';

@NgModule({
    imports: [
        QueuingSystemSharedModule,
        RouterModule.forRoot(ERROR_ROUTES)
    ],
    declarations: [
        ErrorComponent
    ],
    exports: [
        ErrorComponent
    ]
})
export class ErrorModule {
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/error/error.module.ts